import api from '@/api/reports';

const list = (context, companyId) => new Promise(((resolve, reject) => {
    api.list(companyId)
        .then((response) => {
            resolve(response);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
            reject(error);
        });
}));

const get = (context, params) => new Promise(((resolve, reject) => {
    api.get(params)
        .then((response) => {
            resolve(response);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
            reject(error);
        });
}));

const current = (context, params) => new Promise(((resolve, reject) => {
    api.current(params)
        .then((response) => {
            resolve(response);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
            reject(error);
        });
}));

export default {
    list,
    get,
    current,
};

